import * as MdIcons from 'react-icons/md';
const DestinationMarker = ({ text }) => {
    return (
        <div className='customMarkerTo'>
            <MdIcons.MdLocationOn className='mr-1 text-destructive' size={35}/>
            <p className='bg-white px-3 py-2 border shadow rounded'>{text}</p>
        </div>
    );
}
export default DestinationMarker;